// extracted by mini-css-extract-plugin
module.exports = {"indicator":"_1OaLa","alignTop":"My12X","alignBottom":"_1YfHP","alignCenter":"knmvE","circle":"GUBXw","loader":"_20nph","text":"_3y3zt"};